export default __webpack_public_path__ + "static/media/facility_05_2.ee687e96.jpg";